var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }